import { render, staticRenderFns } from "./CommonHeader.vue?vue&type=template&id=af7a86aa&scoped=true&"
import script from "./CommonHeader.vue?vue&type=script&lang=ts&"
export * from "./CommonHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CommonHeader.vue?vue&type=style&index=0&id=af7a86aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7a86aa",
  null
  
)

export default component.exports